import {
  ChangeStatusButton,
  ChatButton,
  EditButton,
  SendEmailButton,
  TransactionHistoryButton,
  ViewButton,
} from "@/components/IconButton/variants";
import {useNavigate} from "react-router-dom";
import {USER_STATUS} from "@/constant/Users/status";

export default function Actions({ row, handleClickRestrict }) {
  const navigate = useNavigate();
  return (
    <div className="w-auto justify-center flex gap-x-1 ">
      <ChangeStatusButton
        isActive={row.original.status !== USER_STATUS.BLOCKED}
        onClick={() => handleClickRestrict(row.original)}
        tooltipText={row.original.status === USER_STATUS.BLOCKED ? "Unblock User" : "Restrict User"}
      />
      <EditButton
        onClick={() => navigate(`/user-management/web-user-list/${row.original.id}`)}
        tooltipText="Edit User Data"
      />
      <ViewButton onClick={() => window.open(row.original.profile_url, '_blank')} tooltipText="View Profile" />
      <ChatButton onClick={() => alert("Message User")} tooltipText="Message User" />
      <SendEmailButton onClick={() => alert("Send Email")} />
      <TransactionHistoryButton onClick={() => alert("Transaction History")} />
    </div>
  );
}
